import React from "react";
import {Image} from 'react-bootstrap';

import "./OperationMode.css";

import icon_process from "../../asset/images/icon_process.png";

// 模块化产品及服务
class OperationMode extends React.Component {
  render() {
    return (
      <div className="mode">
        <div className="mode_content">
          <div className="mode_word">
            <div className="mode_title">Operation mode</div>
            <div className="mode_rectangle"></div>
            <div className="mode_title2">模块化产品及服务架构</div>
            <p className="mode_paragraph">
            我们在广泛的工业节能领域拥有先进节能环保技术，与工业企业、地方政府产业园有广阔合作前景;通过平台化与解耦，将定制化的方案封装为标准化模块，以小规模团队高效运营诸多行业方案;通过有机整合多项适用多种应用场景的节能技术，为客户提供全方位一站式节能服务;
            </p>
          </div>
          <div className="mode_cards">
            <div className="mode_card item1">
              <div className="mode_card_band">
                <div className="mode_card_band_achievement">
                  <span className="mode_card_title">空压板块</span>
                  <Image src={icon_process} />
                  <span className="mode_card_title">数字化平台</span>
                  </div>
                  <div className="mode_card_content">
                    多环节多维度优化，有效提升空压系统运行效率及稳定性
                  </div>
              </div>
            </div>
            <div className="mode_card item2">
              <div className="mode_card_band">
                  <div className="mode_card_band_achievement">
                    <span className="mode_card_title">空调板块</span>
                    <Image src={icon_process} />
                    <span className="mode_card_title">数字化平台</span>
                    </div>
                    <div className="mode_card_content">
                      多种手段多重验证，清晰改造逻辑保证良好中央空调节能效果
                    </div>
                </div>
            </div>
            <div className="mode_card item3">
              <div className="mode_card_band">
                  <div className="mode_card_band_achievement">
                    <span className="mode_card_title">循环水板块</span>
                    <Image src={icon_process} />
                    <span className="mode_card_title">数字化平台</span>
                    </div>
                    <div className="mode_card_content">
                      应用最优技术、产品，精确管理系统需求，提高流体系统能效
                    </div>
                </div>
            </div>
            <div className="mode_card item4">
              <div className="mode_card_band">
                  <div className="mode_card_band_achievement">
                    <span className="mode_card_title">更多板块</span>
                    <Image src={icon_process} />
                    <span className="mode_card_title">数字化平台</span>
                    </div>
                    <div className="mode_card_content">
                      风机板块、冷/热回收板块、蒸汽板块、能源管理及运维平台等
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OperationMode
